import { render, staticRenderFns } from "./YearStudyField.vue?vue&type=template&id=ff3291d2&"
import script from "./YearStudyField.vue?vue&type=script&lang=js&"
export * from "./YearStudyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports